//检查查看卡片权限
export const checkStatusUrl = `/api/hrm/card/checkCardStatus`

//关注与取消关注
export const followUrl = `/api/hrm/user/follow`
export const unfollowUrl = '/api/hrm/user/unfollow'

//预览接口
// export const previewPath = `/papi/app/file/preview?type=redirect&fileId=`
export const previewPath = `/api/app/file/preview?type=redirect&fileId=`

//头像裁切
export const imageCropperCutUrl = '/api/hrm/profile/cut'
export const imageCropperUploadUrl = '/api/hrm/profile/upload'
export const imageCropperFindObjUrl = '/api/file/findFileobj?id='

//二维码
export const getQrcodeUrl = `/api/bs/hrm/card/getResourceImageinfo`